import React, { useState, useEffect } from 'react';
import { FiMapPin, FiCalendar, FiAward, FiBook } from 'react-icons/fi';
import './About.css';
import API_URL from '../config';

const About = () => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_URL}/profile`);
        const data = await res.json();
        if (data.success) setProfile(data.data);
      } catch (error) {
        console.error('Failed to fetch profile');
      }
    };
    fetchData();
  }, []);

  const personalInfo = profile?.personalInfo || { 
    name: 'Manish Mandal', 
    location: 'Hetauda, Nepal', 
    bio: 'Backend Developer who loves building APIs and server-side apps with Node.js.' 
  };
  
  const education = profile?.education?.[0] || {
    institution: "Hetauda City College",
    degree: "B.Sc. CSIT",
    fullDegree: "Bachelor in Computer Science and Information Technology",
    duration: "Feb 2022 - Present",
    coursework: ["Node.js", "Databases", "DSA", "API Development"]
  };

  const awards = profile?.awards || [{ title: "Runner-up at HSMSS logiCon", year: 2024, description: "Coding competition in Hetauda." }];

  return (
    <section className="about section">
      <div className="container">
        <div className="section-title"><h2>About Me</h2></div>

        <div className="about-content">
          <div className="about-text">
            <h3>Hello! I'm {personalInfo.name}</h3>
            <p>{personalInfo.bio}</p>
            <p>I create REST APIs and backend systems using Node.js, Express, and MongoDB.</p>

            <div className="about-info">
              <div className="info-item"><FiMapPin className="info-icon" /><span>{personalInfo.location}</span></div>
              <div className="info-item"><FiBook className="info-icon" /><span>{education.degree} Student</span></div>
            </div>
          </div>

          <div className="about-cards">
            <div className="about-card education-card">
              <div className="card-header"><FiCalendar className="card-icon" /><h4>Education</h4></div>
              <div className="card-content">
                <h5>{education.institution}</h5>
                <p className="degree">{education.degree}</p>
                <p className="full-degree">{education.fullDegree}</p>
                <span className="duration">{education.duration}</span>
                
                {education.coursework && (
                  <div className="coursework">
                    <h6>Courses:</h6>
                    <div className="coursework-tags">
                      {education.coursework.map((course, index) => (
                        <span key={index} className="tag">{course}</span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="about-card awards-card">
              <div className="card-header"><FiAward className="card-icon" /><h4>Awards</h4></div>
              <div className="card-content">
                {awards.map((award, index) => (
                  <div key={index} className="award-item">
                    <div className="award-header">
                      <h5>{award.title}</h5>
                      <span className="award-year">{award.year}</span>
                    </div>
                    <p>{award.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
